import { HTMLTable } from '@blueprintjs/core';
import {
    AlloyAtom,
    AlloyField, AlloyInstance,
    AlloySignature,
    AlloySkolem,
    AlloyTuple
} from 'alloy-ts';
import React from 'react';
import PopoverRow from './PopoverRow';
import SkolemListPopover from './SkolemListPopover';


export interface IFieldHTMLTableProps {
    field: AlloyField,
    highlightSkolems: boolean,
    localNecessity: string | null
    nameFunction: (item: AlloySignature | AlloyField | AlloySkolem) => string,
    skolemColors: Map<AlloySkolem, string>
}

export default function FieldHTMLTable (props: IFieldHTMLTableProps) {

    const types: AlloySignature[] = props.field.types();
    const tuples: AlloyTuple[] = props.field.tuples(props.localNecessity === 'false');

    return (
        <HTMLTable
            bordered={true}
            condensed={true}
            striped={true}>
            <thead>
            <tr>
            {
                types.map((sig: AlloySignature, i: number) => (
                    <th key={sig.id() + i}>
                        {props.nameFunction(sig)}
                    </th>
                ))
            }
            </tr>
            </thead>
            <tbody>
            {
                tuples.map((tuple: AlloyTuple) => {

                    const skolems = tuple.skolems();
                    const ln = tuple.attributes()['LN'];

                    if (props.highlightSkolems && skolems.length) {

                        const colors = skolems.map(s => props.skolemColors.get(s) || '');

                        return (
                            <PopoverRow
                                key={tuple.id()}
                                content={SkolemListPopover(skolems, colors)}
                                colors={colors}>
                                {
                                    tuple.atoms().map((atom: AlloyAtom, i: number) => (
                                        <td key={tuple.id() + '[' + i + ']'}>
                                            {atom.name()}
                                        </td>
                                    ))
                                }
                            </PopoverRow>
                        );

                    } else if (props.localNecessity === ln) {

                        const color = ln === 'true' ? '#15B371' : '#DB3737';
                        const text = ln === 'true' ? 'LN+' : 'LN-';

                        return (
                            <PopoverRow
                                key={tuple.id()}
                                content={<div style={{ backgroundColor: color}}>
                                    {text}
                                </div>}
                                colors={[color]}>
                                {
                                    tuple.atoms().map((atom: AlloyAtom, i: number) => (
                                        <td key={tuple.id() + '[' + i + ']'}>
                                            {atom.name()}
                                        </td>
                                    ))
                                }
                            </PopoverRow>
                        )


                    } else {

                        return (
                            <tr key={tuple.id()}>
                                {
                                    tuple.atoms().map((atom: AlloyAtom, i: number) => (
                                        <td key={tuple.id() + '[' + i + ']'}>
                                            {atom.name()}
                                        </td>
                                    ))
                                }
                            </tr>
                        )

                    }

                })
            }
            </tbody>
        </HTMLTable>
    )

}

function hasLocalNecessity (current: AlloyInstance | undefined) {
    if (current) {
        return current.fields().some(field => {
            return field.tuples().some(tuple => {
                return tuple.attributes().hasOwnProperty('LN');
            });
        });
    }
    return false;
}